import { useParams, useSearch } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { TenantDestinationManager } from '@/features/tenant-destination'
import { useScopedAdminPath } from '@/shared/hooks/use-scoped-admin-path'
import { PageContainer } from '@/shared/ui/page-container'
import { PageHeader } from '@/shared/ui/page-header'

export function TenantDestinationPage() {
  const { t } = useTranslation()
  const scopedAdminPath = useScopedAdminPath()
  const params = useParams({ strict: false })
  const search: { returnTo?: unknown } = useSearch({ strict: false })
  const tenantId = params.tenantId ?? ''
  const returnTo = typeof search.returnTo === 'string' ? search.returnTo.trim() : ''

  return (
    <PageContainer>
      <PageHeader
        title={t('tenantDestination.title', { defaultValue: 'Tenant Destinations' })}
        breadcrumbs={[
          { label: t('sidebar.tenants'), path: scopedAdminPath('/tenant') },
          { label: t('tenantDestination.title', { defaultValue: 'Tenant Destinations' }) },
        ]}
      />
      <TenantDestinationManager
        tenantId={tenantId}
        autoOpenPicker={Boolean(returnTo)}
        returnTo={returnTo}
      />
    </PageContainer>
  )
}
